import { Box, Flex, Heading, List, ListItem, VStack } from "@chakra-ui/react";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import Address from "components/Shared/Address";
import CreateButton from "components/Shared/CreateButton";
import LoadingSpinner from "components/Shared/PageLoadingSpinner";
import { EditButton } from "components/Shared/Panel/Editable";
import DeleteManufacturingFacilityButton from "./DeleteButton";

const fragment = gql(/* GraphQL */ `
  fragment ProductLinePanelManufacturingFacilityListItem on ManufacturingFacility {
    id
    name
    address {
      id
      ...AddressComponentFields
    }
  }
`);

type Props = {
  facilities: FragmentType<typeof fragment>[] | null | undefined;
  isLoading: boolean;
  onAdd: () => void;
  onEdit: (facilityId: UUID) => void;
};

export default function ManufacturingFacilitiesList({
  facilities,
  isLoading,
  onAdd,
  onEdit,
}: Props) {
  return (
    <>
      {!!facilities?.length && (
        <VStack as={List} gap={3} alignItems="stretch">
          {facilities.map((facilityFragment) => {
            const facility = getFragmentData(fragment, facilityFragment);
            return (
              <ListItem
                key={facility.id}
                display="flex"
                borderWidth={1}
                borderRadius="md"
                p={4}
                justifyContent="space-between"
                alignItems="center"
                gap={4}
              >
                <Box>
                  <Heading size="sm" mb={1}>
                    {facility.name}
                  </Heading>
                  <Address address={facility.address} isMultiLine={false} />
                </Box>

                <Flex gap={2} alignItems="center">
                  <DeleteManufacturingFacilityButton facilityId={facility.id} />
                  <EditButton onClick={() => onEdit(facility.id)} />
                </Flex>
              </ListItem>
            );
          })}
        </VStack>
      )}

      {!facilities?.length && !isLoading && (
        <Box textAlign="center" color="gray.600">
          No manufacturing facilities found.
        </Box>
      )}

      {isLoading && <LoadingSpinner />}

      <Flex justify="center" mt={5}>
        <CreateButton type="button" colorScheme="pinkButton" onClick={onAdd}>
          Add Manufacturing Facility
        </CreateButton>
      </Flex>
    </>
  );
}
